import React from 'react';
import { PostMetadata } from './PostMetadata';
import { PostBubble } from './PostBubble';
import { PostUpdateForm } from '../forms/PostUpdateForm';
import { PostReply, PostTypes } from '../Post.types';
import { HeadingHierarchy } from '../../Heading/Heading';

type PostBody = {
  post: PostReply;
  editEditorId: string;
  type: PostTypes;
  hash: string;
  headingHierarchy: HeadingHierarchy;
  form?: PostUpdateForm | undefined;
};

/**
 * Displaying User Information and the content.
 *
 * If the
 */
export function PostBody({ editEditorId, type, form, hash, headingHierarchy, post }: PostBody) {
  const editorIsOpen = hash?.includes(editEditorId);
  const currentOpenFormIsUpdate = form && form === post?.updateForm;
  const editFormIsOpen = editorIsOpen && currentOpenFormIsUpdate;

  return (
    <div className="posts__body">
      {!editFormIsOpen && (
        <>
          <PostMetadata model={post} />
          <PostBubble model={post} />
        </>
      )}
      <div className="posts__skip-to-editor" id={editEditorId} key={editEditorId}>
        <div className="posts__skip-to-editor-content">
          {editFormIsOpen && <PostUpdateForm type={type} form={form} post={post} headingHierarchy={headingHierarchy} />}
        </div>
      </div>
    </div>
  );
}
